import PT from "prop-types";
import get from "lodash/get";
import React, { useEffect, useState } from "react";
import { SocialShare, StoryElement } from "@quintype/components";
import "./video.m.css";
import { Headline } from "../../../Atoms/Headline";

function getPrimaryVideo(cards) {
  const headerVideo = [];
  cards.forEach(function (card) {
    card["story-elements"].forEach(function (element) {
      if (element.type === "youtube-video" || element.type === "jsembed" || element.subtype === "dailymotion-video") {
        headerVideo.push(element);
      }
    });
  });
  return headerVideo[0];
}

const VideoStoryTest = ({ story }) => {
  const [imgId, setImgId] = useState();
  story = Object.assign({}, story);
  const primaryVideo = getPrimaryVideo(story.cards);

  useEffect(() => {
    if (typeof window === "undefined") {
      return null;
    } else {
      if (primaryVideo.type === "jsembed") {
        const decodedHTML = window.atob(primaryVideo["embed-js"]);

        const extractId = decodedHTML.substring(decodedHTML.indexOf("id=") + 3, decodedHTML.lastIndexOf("&"));
        setImgId(extractId);
      }
    }
  }, [primaryVideo]);

  const primaryVideoType = primaryVideo.type;
//I am trying to check embed-js for jsembed and decode it here.

  return (
    <div styleName="top-container">
      <div styleName="main-container">
        <div styleName="main">
          <div styleName="ad-container">
            <div styleName="mob-ad">
              <div>Mobile</div>
            </div>
            <div styleName="dsktop-ad">
              <div>Desktop</div>
            </div>
          </div>
          <div styleName="ad-container">
            <div styleName="mob-ad">
              <div>Mobile 2</div>
            </div>
            <div styleName="dsktop-ad">
              <div>Desktop 2</div>
            </div>
          </div>
        </div>
        <div styleName="blank-story">
          <div styleName="sticky-social-share">
            Social share component
          </div>
          <div className="voice-article" styleName="story-container">
            <div styleName="story-header">
              <Headline story={story} />
              {primaryVideoType !== "youtube-video" ? (
                <StoryElement element={primaryVideo} story={story} />
              ) : (
                <iframe width="100%" height="400vh" src={primaryVideo["embed-url"]}></iframe>
              )}
            </div>
          </div>
          Sidebar element
        </div>
      </div>
    </div>
  );
};

VideoStoryTest.propTypes = {
  story: PT.object.isRequired,
};

export { VideoStoryTest };
